module.exports = __webpack_public_path__ + "img/iesEst.671a1ae1.jpg";